// extracted by mini-css-extract-plugin
export default {"wrapper":"Coupon_wrapper__Covzb","left-container":"Coupon_left-container__Uoqsf","right-container":"Coupon_right-container__2yy9q"};